// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.privacy-container {

    color: black;
  background: #f2f2f2;
}

/* Header */
.privacy-header {
  background: #165aa7;
  color: white;
  padding: 20px 0;
}

.privacy-header-content {
  width: 900px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: black;
}

.privacy-header h2 {
  font-size: 16px;
  margin-bottom: 6px;
  color: black;
}

.privacy-header p {
  font-size: 11px;
  width: 350px;
  color: black;
}

.privacy-header-img {
  width: 180px;
  height: 80px;
  object-fit: cover;
}

/* Body */
.privacy-body {
  width: 900px;
  margin: 40px 20px;
  display: flex;
  gap: 100px;
}

/* Left */
.privacy-left {
  width: 250px;
}

.privacy-box {
  background: #fff;
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 10px;
  font-size: 14px;
}

.privacy-box h4 {
  font-size: 14px;
  margin-bottom: 5px;
  color: black;
}

.privacy-box.highlight {
  background: #e6f0ff;
}

/* Right */
.privacy-right {
  flex: 1 1;
}

.privacy-main-box {
  background: #fff;
  border: 1px solid #ccc;
  padding: 15px;
  font-size: 14px;
}

.privacy-main-box h3 {
  font-size: 14px;
  margin-bottom: 10px;
  color: black;
}

.privacy-main-box h4 {
  margin-top: 12px;
  font-size: 14px;
}

.privacy-main-box p {
  margin: 6px 0;
  color: black;
}

.privacy-main-box ul {
  padding-left: 15px;
  color: black;
}

.privacy-main-box li {
  margin: 4px 0;
  color: black;
}

/* Table */
.privacy-main-box table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.privacy-main-box th,
.privacy-main-box td {
  border: 1px solid #ccc;
  padding: 6px;
  text-align: left;
  font-size: 14px;
}

.privacy-main-box th {
  background: #f5f5f5;
}

@media (max-width: 768px) {
  .privacy-header {
    padding: 20px 15px;
  }

  .privacy-header-content {
    width: 100%;
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }

  .privacy-header h2 {
    font-size: 18px;
  }

  .privacy-header p {
    width: 100%;
    font-size: 12px;
  }

  .privacy-header-img {
    width: 140px;
    height: auto;
  }

  .privacy-body {
    width: 100%;
    margin: 20px 0;
    padding: 0 15px;
    flex-direction: column;
    gap: 20px;
  }

  .privacy-left {
    width: 100%;
  }

  .privacy-right {
    width: 100%;
  }

  .privacy-box,
  .privacy-main-box {
    padding: 12px;
    font-size: 13px;
  }

  .privacy-main-box h3,
  .privacy-main-box h4,
  .privacy-box h4 {
    font-size: 14px;
  }

  .privacy-main-box table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }

  .privacy-main-box th,
  .privacy-main-box td {
    font-size: 12px;
    padding: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/privacyPolicy/privacy.css"],"names":[],"mappings":"AAAA,cAAc;AACd;;IAEI,YAAY;EACd,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,UAAU;AACZ;;AAEA,SAAS;AACT;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA,UAAU;AACV;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;IACX,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,aAAa;IACb,eAAe;EACjB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;IACf,YAAY;EACd;AACF","sourcesContent":["/* Container */\n.privacy-container {\n\n    color: black;\n  background: #f2f2f2;\n}\n\n/* Header */\n.privacy-header {\n  background: #165aa7;\n  color: white;\n  padding: 20px 0;\n}\n\n.privacy-header-content {\n  width: 900px;\n  margin: auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: black;\n}\n\n.privacy-header h2 {\n  font-size: 16px;\n  margin-bottom: 6px;\n  color: black;\n}\n\n.privacy-header p {\n  font-size: 11px;\n  width: 350px;\n  color: black;\n}\n\n.privacy-header-img {\n  width: 180px;\n  height: 80px;\n  object-fit: cover;\n}\n\n/* Body */\n.privacy-body {\n  width: 900px;\n  margin: 40px 20px;\n  display: flex;\n  gap: 100px;\n}\n\n/* Left */\n.privacy-left {\n  width: 250px;\n}\n\n.privacy-box {\n  background: #fff;\n  border: 1px solid #ccc;\n  padding: 10px;\n  margin-bottom: 10px;\n  font-size: 14px;\n}\n\n.privacy-box h4 {\n  font-size: 14px;\n  margin-bottom: 5px;\n  color: black;\n}\n\n.privacy-box.highlight {\n  background: #e6f0ff;\n}\n\n/* Right */\n.privacy-right {\n  flex: 1;\n}\n\n.privacy-main-box {\n  background: #fff;\n  border: 1px solid #ccc;\n  padding: 15px;\n  font-size: 14px;\n}\n\n.privacy-main-box h3 {\n  font-size: 14px;\n  margin-bottom: 10px;\n  color: black;\n}\n\n.privacy-main-box h4 {\n  margin-top: 12px;\n  font-size: 14px;\n}\n\n.privacy-main-box p {\n  margin: 6px 0;\n  color: black;\n}\n\n.privacy-main-box ul {\n  padding-left: 15px;\n  color: black;\n}\n\n.privacy-main-box li {\n  margin: 4px 0;\n  color: black;\n}\n\n/* Table */\n.privacy-main-box table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n}\n\n.privacy-main-box th,\n.privacy-main-box td {\n  border: 1px solid #ccc;\n  padding: 6px;\n  text-align: left;\n  font-size: 14px;\n}\n\n.privacy-main-box th {\n  background: #f5f5f5;\n}\n\n@media (max-width: 768px) {\n  .privacy-header {\n    padding: 20px 15px;\n  }\n\n  .privacy-header-content {\n    width: 100%;\n    flex-direction: column;\n    text-align: center;\n    gap: 15px;\n  }\n\n  .privacy-header h2 {\n    font-size: 18px;\n  }\n\n  .privacy-header p {\n    width: 100%;\n    font-size: 12px;\n  }\n\n  .privacy-header-img {\n    width: 140px;\n    height: auto;\n  }\n\n  .privacy-body {\n    width: 100%;\n    margin: 20px 0;\n    padding: 0 15px;\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .privacy-left {\n    width: 100%;\n  }\n\n  .privacy-right {\n    width: 100%;\n  }\n\n  .privacy-box,\n  .privacy-main-box {\n    padding: 12px;\n    font-size: 13px;\n  }\n\n  .privacy-main-box h3,\n  .privacy-main-box h4,\n  .privacy-box h4 {\n    font-size: 14px;\n  }\n\n  .privacy-main-box table {\n    display: block;\n    overflow-x: auto;\n    white-space: nowrap;\n  }\n\n  .privacy-main-box th,\n  .privacy-main-box td {\n    font-size: 12px;\n    padding: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
